module.exports = __webpack_public_path__ + "img/eye.52785d83.svg";